import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import BlogArticleView from '../views/BlogArticleView.vue'
import CityPageView from '../views/CityPageView.vue'
import { blogArticles } from '../data/blogArticles'
import { cityPages } from '../data/cityPages'

const blogArticleRoutes = blogArticles.map((article) => ({
  path: `/blog/${article.slug}`,
  name: `BlogArticle-${article.slug}`,
  component: BlogArticleView,
  meta: { slug: article.slug }
}))

const blogArticleRedirects = blogArticles.map((article) => ({
  path: `/blog/${article.slug}.html`,
  redirect: `/blog/${article.slug}`
}))

const cityRoutes = cityPages.map((page) => ({
  path: `/${page.slug}`,
  name: `City-${page.slug}`,
  component: CityPageView,
  meta: { slug: page.slug }
}))

const cityRedirects = cityPages.map((page) => ({
  path: `/${page.slug}.html`,
  redirect: `/${page.slug}`
}))

const routes = [
  { path: '/', name: 'Home', component: HomeView },
  { path: '/menu', name: 'Menu', component: () => import('../views/MenuView.vue') },
  { path: '/gallery', name: 'Gallery', component: () => import('../views/GalleryView.vue') },
  { path: '/service-areas', name: 'ServiceAreas', component: () => import('../views/ServiceAreasView.vue') },
  { path: '/booking', name: 'Booking', component: () => import('../views/BookingView.vue') },
  { path: '/large-events', name: 'LargeEvents', component: () => import('../views/LargeEventsView.vue') },
  { path: '/blog', name: 'Blog', component: () => import('../views/BlogView.vue') },
  ...blogArticleRoutes,
  ...cityRoutes,
  { path: '/index.html', redirect: '/' },
  { path: '/menu/index.html', redirect: '/menu' },
  { path: '/gallery/index.html', redirect: '/gallery' },
  { path: '/service-areas/index.html', redirect: '/service-areas' },
  { path: '/booking.html', redirect: '/booking' },
  { path: '/large-events.html', redirect: '/large-events' },
  { path: '/blog/index.html', redirect: '/blog' },
  ...blogArticleRedirects,
  ...cityRedirects,
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('../views/NotFoundView.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, top: 90 }
    return { top: 0 }
  },
  routes
})

export default router
